import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import * as QueryString from 'query-string';

// eslint-disable-next-line import/prefer-default-export
export async function loginRequest(creds) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    isPublic: true,
  };

  const { data } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/api/user/v2/account/login_session/`,
      QueryString.stringify(creds),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return {
    redirectUrl: data.redirect_url || `${getConfig().LMS_BASE_URL}/dashboard`,
    success: data.success || false,
  };
}

export async function verifyUserCredentials(email_or_username, password) {
  const url = `${getConfig().LMS_BASE_URL}/user_api/verify-user-credentials/`;
  const client = getAuthenticatedHttpClient();
  try {
    const { data } = await client.post(url, { email_or_username, password }, { isPublic: true });
    return data;
  } catch (err) {
    // normalize error
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
}

export async function twoFactorVerifyCode(code, identifier) {
  const url = `${getConfig().LMS_BASE_URL}/user_api/verify/`;
  const client = getAuthenticatedHttpClient();
  try {
    const { data } = await client.post(url, { code, identifier }, { isPublic: true });
    return data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
}

export async function twoFactorResendRequest(email) {
  const url = `${getConfig().LMS_BASE_URL}/user_api/resend-otp/`;
  const client = getAuthenticatedHttpClient();
  try {
    const { data } = await client.post(url, { email }, { isPublic: true });
    return data;
  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw err;
  }
}
